import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { VIEW_ONLY, EDITOR, NO_ACCESS } = PERMISSIONS_OPTIONS_VALUE;

export const DELIVERIES_AND_PICKUPS_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_CREATE_ORDER: true,
    HIDE_EDIT_ORDER: true,
    HIDE_DELETE_AND_CANCEL_ORDER: true,
    HIDE_CONFIRM_ORDER: true,
    HIDE_EXPORT_ORDERS: true,
    KEEP_PRINT_AWB_TRACK_ORDER_ONLY: true,
    HIDE_MULTI_SELECT_CHECKBOXES: true,
    HIDE_SCHEDULE_PICKUP: true,
    HIDE_EXPORT_PICKUPS: true,
    HIDE_DELETE_PICKUP: true,
    HIDE_EDIT_PICKUP: true,
    HIDE_PACKAGE_SHOP_TAB: true,
    HIDE_PACKAGE_CANCEL_ORDER: true
  },
  [EDITOR]: {
    HIDE_DELETE_AND_CANCEL_ORDER: true,
    HIDE_EXPORT_ORDERS: true,
    HIDE_DELETE_PICKUP: true,
    HIDE_EXPORT_PICKUPS: true,
    HIDE_PACKAGE_CANCEL_ORDER: true
  },
  [NO_ACCESS]: {
    HIDE_CONFIRM_ORDER: true,
    HIDE_CREATE_ORDER: true,
    HIDE_EDIT_ORDER: true,
    HIDE_SCHEDULE_PICKUP: true,
    HIDE_ORDERS_TAB: true,
    HIDE_PICKUPS_TAB: true,
    HIDE_PACKAGING_TAB: true
  }
};
